import {
  DefaultColorStyle,
  DefaultFontStyle,
  isFontEntry
} from "@tldraw/editor";
function isPaletteColor(value) {
  return typeof value === "object" && value !== null && "solid" in value;
}
function getColorStyleItems(colors) {
  const result = [];
  const seen = /* @__PURE__ */ new Set();
  for (const name of DefaultColorStyle.values) {
    if (name in colors && isPaletteColor(colors[name])) {
      if (name === "white") continue;
      result.push({ value: name, icon: "color" });
      seen.add(name);
    }
  }
  for (const [key, value] of Object.entries(colors)) {
    if (!seen.has(key) && key !== "white" && isPaletteColor(value)) {
      result.push({ value: key, icon: "color" });
    }
  }
  return result;
}
const defaultFontIcons = {
  draw: "font-draw",
  sans: "font-sans",
  serif: "font-serif",
  mono: "font-mono"
};
function getFontStyleItems(theme) {
  const result = [];
  const seen = /* @__PURE__ */ new Set();
  for (const name of DefaultFontStyle.values) {
    const entry = theme.fonts[name];
    if (name in theme.fonts && isFontEntry(entry)) {
      result.push({ value: name, icon: fontIcon(entry, name) });
      seen.add(name);
    }
  }
  for (const [key, value] of Object.entries(theme.fonts)) {
    if (!seen.has(key) && isFontEntry(value)) {
      result.push({ value: key, icon: fontIcon(value, key) });
    }
  }
  return result;
}
function fontIcon(font, name) {
  if (font.icon != null) return font.icon;
  return defaultFontIcons[name] ?? "font-draw";
}
const STYLES = {
  fill: [
    { value: "none", icon: "fill-none" },
    { value: "semi", icon: "fill-semi" },
    { value: "solid", icon: "fill-solid" }
  ],
  fillExtra: [
    { value: "pattern", icon: "fill-pattern" },
    { value: "lined-fill", icon: "fill-lined-fill" },
    { value: "fill", icon: "fill-fill" }
  ],
  dash: [
    { value: "draw", icon: "dash-draw" },
    { value: "dashed", icon: "dash-dashed" },
    { value: "dotted", icon: "dash-dotted" },
    { value: "solid", icon: "dash-solid" }
  ],
  size: [
    { value: "s", icon: "size-small" },
    { value: "m", icon: "size-medium" },
    { value: "l", icon: "size-large" },
    { value: "xl", icon: "size-extra-large" }
  ],
  font: [
    { value: "draw", icon: "font-draw" },
    { value: "sans", icon: "font-sans" },
    { value: "serif", icon: "font-serif" },
    { value: "mono", icon: "font-mono" }
  ],
  textAlign: [
    { value: "start", icon: "text-align-left" },
    { value: "middle", icon: "text-align-center" },
    { value: "end", icon: "text-align-right" }
  ],
  horizontalAlign: [
    { value: "start", icon: "horizontal-align-start" },
    { value: "middle", icon: "horizontal-align-middle" },
    { value: "end", icon: "horizontal-align-end" }
  ],
  verticalAlign: [
    { value: "start", icon: "vertical-align-start" },
    { value: "middle", icon: "vertical-align-middle" },
    { value: "end", icon: "vertical-align-end" }
  ],
  arrowKind: [
    { value: "arc", icon: "arrow-arc" },
    { value: "elbow", icon: "arrow-elbow" }
  ],
  arrowheadStart: [
    { value: "none", icon: "arrowhead-none" },
    { value: "arrow", icon: "arrowhead-arrow" },
    { value: "triangle", icon: "arrowhead-triangle" },
    { value: "square", icon: "arrowhead-square" },
    { value: "dot", icon: "arrowhead-dot" },
    { value: "diamond", icon: "arrowhead-diamond" },
    { value: "inverted", icon: "arrowhead-triangle-inverted" },
    { value: "bar", icon: "arrowhead-bar" }
  ],
  arrowheadEnd: [
    { value: "none", icon: "arrowhead-none" },
    { value: "arrow", icon: "arrowhead-arrow" },
    { value: "triangle", icon: "arrowhead-triangle" },
    { value: "square", icon: "arrowhead-square" },
    { value: "dot", icon: "arrowhead-dot" },
    { value: "diamond", icon: "arrowhead-diamond" },
    { value: "inverted", icon: "arrowhead-triangle-inverted" },
    { value: "bar", icon: "arrowhead-bar" }
  ],
  spline: [
    { value: "line", icon: "spline-line" },
    { value: "cubic", icon: "spline-cubic" }
  ]
};
export {
  STYLES,
  getColorStyleItems,
  getFontStyleItems
};
//# sourceMappingURL=styles.mjs.map
